import { useEffect } from "react";

const FitBounds = ({ coordinates, zoom, resizeTrigger }) => {
  // eslint-disable-next-line global-require
  const { useMap } = require("react-leaflet");
  const map = useMap();

  useEffect(() => {
    if (!coordinates.length) return;

    // eslint-disable-next-line global-require
    const L = require("leaflet");
    const requestFn =
      typeof window !== "undefined" && window.requestAnimationFrame
        ? window.requestAnimationFrame
        : (fn) => window.setTimeout(fn, 0);

    map.whenReady(() => {
      requestFn(() => {
        map.invalidateSize();

        if (coordinates.length === 1) {
          map.setView([coordinates[0].lat, coordinates[0].lon], zoom);
          return;
        }

        const bounds = L.latLngBounds(coordinates.map((c) => [c.lat, c.lon]));

        map.fitBounds(bounds, { padding: [50, 50] });
      });
    });
  }, [coordinates, map, resizeTrigger, zoom]);

  return null;
};

export default FitBounds;
